import { IoIosClose } from 'react-icons/io';

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@frontend/components/ui/avatar';
import { Button } from '@frontend/components/ui/button';
import { PopoverTrigger } from '@frontend/components/ui/popover';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@frontend/components/ui/tooltip';
import { useDirectoryMe } from '@frontend/shared/hooks/useDirectory';

export function AppAccountButton({
  isOpen,
  onToggle,
}: {
  isOpen: boolean;
  onToggle: () => void;
}) {
  const me = useDirectoryMe();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="fixed bottom-5 left-5 inline-block h-12 w-12">
            <PopoverTrigger asChild>
              <Button
                variant="ghost"
                onClick={onToggle}
                className="h-12 w-12 rounded-full p-0 shadow-lg transition-all duration-300 hover:bg-transparent"
                style={{
                  boxShadow:
                    '0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16)',
                  zIndex: 9999999,
                }}
              >
                <Avatar
                  className="h-12 w-12 transition-opacity duration-300"
                  style={{ opacity: isOpen ? 0 : 1 }}
                >
                  <AvatarImage src={me.image} alt={me.name} />
                  <AvatarFallback>{me.name?.[0]}</AvatarFallback>
                </Avatar>

                <IoIosClose
                  className="absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300"
                  style={{ opacity: isOpen ? 1 : 0 }}
                />
              </Button>
            </PopoverTrigger>
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          {isOpen ? 'Close' : 'Account'}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
